/*
 * Copyright (c) 2017 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschuetzt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulaessig. Dies gilt
 * insbesondere fuer Vervielfaeltigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht uebergeben ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 *
 */
import TSAbstractEntity from './TSAbstractEntity';
import {TSSerializable} from './TSSerializable';
import moment from 'moment';
import {TSLeistungsart} from './enums/TSLeistungsart';
import DateUtil from '../utils/DateUtil';

export default class TSFremdkostenDaten extends TSAbstractEntity implements TSSerializable<TSFremdkostenDaten> {

    private _firma: string;

    private _firmensitz: string;

    private _leistungsart: TSLeistungsart;

    private _rechnungsdatum: moment.Moment | undefined;
    private _rechnungsnummer: string;
    private _rechnungsbetrag: number;
    private _berechtigterBetrag: number;

    public get firma(): string {
        return this._firma;
    }

    public set firma(value: string) {
        this._firma = value;
    }

    public get firmensitz(): string {
        return this._firmensitz;
    }

    public set firmensitz(value: string) {
        this._firmensitz = value;
    }

    public get leistungsart(): TSLeistungsart {
        return this._leistungsart;
    }

    public set leistungsart(value: TSLeistungsart) {
        this._leistungsart = value;
    }

    public get rechnungsdatum(): moment.Moment|any {
        return this._rechnungsdatum;
    }

    public set rechnungsdatum(value: moment.Moment|any) {
        this._rechnungsdatum = value;
    }

    public get rechnungsnummer(): string {
        return this._rechnungsnummer;
    }

    public set rechnungsnummer(value: string) {
        this._rechnungsnummer = value;
    }

    public get rechnungsbetrag(): number {
        return this._rechnungsbetrag;
    }

    public set rechnungsbetrag(value: number) {
        this._rechnungsbetrag = value;
    }

    public get berechtigterBetrag(): number {
        return this._berechtigterBetrag;
    }

    public set berechtigterBetrag(value: number) {
        this._berechtigterBetrag = value;
    }

    deserialize(restObject: any): TSFremdkostenDaten {
        super.deserialize(restObject);
        this.firma = restObject.firma;
        this.firmensitz = restObject.firmensitz;
        this.leistungsart = restObject.leistungsart;
        this.rechnungsdatum = DateUtil.localDateToMoment(restObject.rechnungsdatum);
        this.rechnungsnummer = restObject.rechnungsnummer;
        this.rechnungsbetrag = restObject.rechnungsbetrag;
        this.berechtigterBetrag = restObject.berechtigterBetrag;
        return this;
    }

    serialize(restObject: any): any {
        super.serialize(restObject);

        restObject.firma = this.firma;
        restObject.firmensitz = this.firmensitz;
        restObject.leistungsart = this.leistungsart;
        restObject.rechnungsnummer = this.rechnungsnummer;
        restObject.rechnungsbetrag = this.rechnungsbetrag;
        restObject.berechtigterBetrag = this.berechtigterBetrag;

        if (this.rechnungsdatum) {
            restObject.rechnungsdatum = DateUtil.momentToLocalDate(this.rechnungsdatum);
        }

        return restObject;
    }
}



// WEBPACK FOOTER //
// ./src/app/models/TSFremdkostenDaten.ts